(function () {
  const WRAPPER_SELECTOR = '.reveal-wrapper[data-letter-reveal="true"]';
  const TEXT_SELECTOR = 'h1, h2, h3, h4, h5, h6, p';

  const LETTER_DELAY = 0.035;
  const LETTER_DURATION = 0.45;
  const LINE_GAP = 0.25;
function splitText(el) {
  if (el.dataset.revealDone) return;

  el.dataset.revealDone = 'true';

  const text = el.textContent.trim();
  el.textContent = '';

  const words = text.split(' ');

  let globalIndex = 0;

  words.forEach((word, wIndex) => {
    const wordSpan = document.createElement('span');
    wordSpan.className = 'reveal-word';

    [...word].forEach((char) => {
      const charSpan = document.createElement('span');
      charSpan.className = 'reveal-char';
      charSpan.textContent = char;

      charSpan.style.animationDelay = `${globalIndex * LETTER_DELAY}s`;
      globalIndex++;

      wordSpan.appendChild(charSpan);
    });

    el.appendChild(wordSpan);

    if (wIndex !== words.length - 1) {
      el.appendChild(document.createTextNode(' '));
      globalIndex++; // maintain spacing rhythm
    }
  });
}


  function lineDuration(len) {
    return len * LETTER_DELAY + LETTER_DURATION + LINE_GAP;
  }

  function revealSequentially(wrapper) {
    const elements = [...wrapper.querySelectorAll(TEXT_SELECTOR)]
      .filter(el => el.textContent.trim().length);

    let delay = 0;

    elements.forEach(el => {
      const len = el.textContent.length;

      setTimeout(() => {
        el.classList.add('reveal-line-active');
        splitText(el);
      }, delay * 300);

      delay += lineDuration(len);
    });
  }

  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;

      revealSequentially(entry.target);
      obs.unobserve(entry.target);
    });
  }, { threshold: 0.4 });

  function init() {
    document.querySelectorAll(WRAPPER_SELECTOR).forEach(wrapper => {
      if (wrapper.dataset.observed) return;
      wrapper.dataset.observed = 'true';
      observer.observe(wrapper);
    });
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
